// --- React & Redux
import React from "react";
import { useSelector } from "react-redux";
// --- Components
import { UploadJobTasksList } from "tap/components/UploadJobTasksList";

/**
 * Lists invalid/error tasks from the last licensing job upload.
 */
export function LicensingUploadTasksForm() {
  const { licensingJobUploadTasks } = useSelector((state) => state.licensingJobs);

  return <UploadJobTasksList tasks={licensingJobUploadTasks} />;
}
